<template>
  <div>
    <div v-if="$store.state.user.clientID" :key="$root.time">
      <h1 class="main-heading">Fuels & Electricity</h1>
      <SectionNavigator
        :sections="$root.fuelsAndElectricity.sections"
        :schemas="$root.fuelsAndElectricity.schemas"
      />
      <router-view />
    </div>
  </div>
</template>

<script>
import SectionNavigator from '../SectionNavigator'

// import routes from '../../router/index'
export default {
  name: 'category-fuels-and-electricity',
  props: { sections: String, schemas: Array },
  components: {
    SectionNavigator
  }
}
</script>
